module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg2NCAyNTZhMzIgMzIgMCAwIDEgMzIgMzJ2NTc2YTMyIDMyIDAgMCAxLTMyIDMySDI4OGEzMiAzMiAwIDAgMS0zMi0zMlYyODhhMzIgMzIgMCAwIDEgMzItMzJoNTc2eiBtLTIyNC0xMjhhMzIgMzIgMCAwIDEgMy43IDYzLjhMNjQwIDE5MkgxOTJ2NDQ4YTMyIDMyIDAgMCAxLTYzLjggMy43TDEyOCA2NDBWMTkyYTY0IDY0IDAgMCAxIDU5LjItNjMuOEwxOTIgMTI4aDQ0OHoiIGZpbGw9IiMwIiBwLWlkPSI0ODIyIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Copy 2-filled.svg
// module id = tW9k
// module chunks = 75